<template>
  <div class="status warn">
    <h2>Holiday closure</h2>
    <p>The Registry of Births, Deaths and Marriages located at Level 32, 180 Ann Street, Brisbane will be closed from 4.30pm <strong>Tuesday 24 December 2024</strong> to <strong>Wednesday 1 January 2025</strong> for the Christmas break.</p>
    <p>We will re-open on Thursday 2 January at 8.30am.</p>
  </div>
</template>

<script>
export default {
  name: 'ClosureNotice',
  data () {
    return {}
  }
}
</script>
